import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils/cn';
/**
 * Shared width-constraint wrapper. Applies the `container-grid` utility, which
 * centres content, caps it at the site's max content width (1888px), and applies
 * a consistent 16px horizontal gutter — so every section on the page aligns to
 * one grid. A full-bleed background (e.g. `band`) wraps its inner content in a
 * `Container`; anything meant to bleed edge to edge (e.g. a marquee) simply isn't
 * wrapped. Layout-only: it sets no colour or typography.
 *
 * The grid values live as tokens (`--grid-max-width` / `--grid-gutter`) behind
 * the `container-grid` utility, so this component carries no magic numbers.
 */
export const Container = ({ as = 'div', className, ...props }) => {
    const Component = as;
    return _jsx(Component, { className: cn('container-grid', className), ...props });
};
